(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boxed-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxed-testimonials-stories"] && !Shopify.designMode) return;
  try {
    
  class BoxedTestimonialsSlider {
    constructor(container) {
      this.container = container;
      this.items = Array.from(container.querySelectorAll('.box-testimonials__item'));
      this.currentIndex = 0;

      // Find buttons - they may be inside slideshow-arrows custom element
      const section = container.closest('.box-testimonials');
      this.prevButton = section.querySelector('.slideshow-control--previous');
      this.nextButton = section.querySelector('.slideshow-control--next');

      if (this.items.length === 0) return;

      this.init();
    }

    init() {
      this.updateVisibility();
      this.updateButtons();
      this.bindEvents();
      this.bindResize();
    }

    bindResize() {
      window.addEventListener('resize', () => {
        this.updateVisibility();
        this.updateButtons();
      });
    }

    bindEvents() {
      // Use event delegation on the section for arrow buttons
      // This handles cases where slideshow-arrows renders asynchronously
      const section = this.container.closest('.box-testimonials');

      section.addEventListener('click', (e) => {
        const prevBtn = e.target.closest('.slideshow-control--previous');
        const nextBtn = e.target.closest('.slideshow-control--next');

        if (prevBtn) {
          e.preventDefault();
          this.navigate(-1);
        } else if (nextBtn) {
          e.preventDefault();
          this.navigate(1);
        }
      });

      // Also bind directly if buttons exist
      if (this.prevButton) {
        this.prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigate(-1);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigate(1);
        });
      }

      // Touch swipe support
      this.bindSwipe();
    }

    bindSwipe() {
      let touchStartX = 0;
      let touchEndX = 0;
      const minSwipeDistance = 50;

      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.container.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX, minSwipeDistance);
      }, { passive: true });
    }

    handleSwipe(startX, endX, minDistance) {
      const diff = startX - endX;

      if (Math.abs(diff) < minDistance) return;

      if (diff > 0) {
        // Swiped left - go next
        this.navigate(1);
      } else {
        // Swiped right - go previous
        this.navigate(-1);
      }
    }

    navigate(direction) {
      const newIndex = this.currentIndex + direction;

      if (newIndex < 0 || newIndex >= this.items.length) return;

      this.currentIndex = newIndex;
      this.updateVisibility();
      this.updateButtons();
    }

    updateVisibility() {
      // On mobile, show only current item
      if (window.innerWidth < 750) {
        this.items.forEach((item, index) => {
          item.style.display = index === this.currentIndex ? 'grid' : 'none';
        });
      } else {
        // On desktop, show all items
        this.items.forEach(item => {
          item.style.display = 'grid';
        });
      }
    }

    updateButtons() {
      const isMobile = window.innerWidth < 750;
      if (!isMobile) {
        // On desktop, disable both buttons if there's nothing to navigate
        if (this.prevButton) this.prevButton.disabled = true;
        if (this.nextButton) this.nextButton.disabled = true;
        return;
      }
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex === this.items.length - 1;
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonials);
  } else {
    initTestimonials();
  }

  function initTestimonials() {
    const sliders = document.querySelectorAll('[data-testimonials-slider]');
    sliders.forEach(slider => new BoxedTestimonialsSlider(slider));
  }

  // Re-initialize on Shopify section load
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('[data-testimonials-slider]');
    if (slider) {
      new BoxedTestimonialsSlider(slider);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
